import React from "react";
// import trace from "./util";

// locales
import i18n from '../../i18n';
// the hoc
import { withTranslation } from 'react-i18next';

// vars
import { LOCATION_ARRAY } from "../../utils/const";

// components
import DropDown from "../bootstrap/DropDown";
import SelectApplyBtn from "./SelectApplyBtn";

// style
import "./SelectLocation.scss";

class SelectLocation extends React.Component {

	radioArr = LOCATION_ARRAY;

	constructor(props) {
		super(props);
		this._onclickHandler = props.onClick;
		this.state = {
			radioBtnState: '',
		};
	}

	// ____________________________________ check ____________________________________

	isRadioDisabled(value) {
		if (!this.props.locationArray.includes(value)) {
			return true;
		} else {
			return false;
		}
	}

	// ____________________________________ onHandlers ____________________________________

	onRadioChangeHandler(e) {
		const id = e.currentTarget.id;
		this.setState({
			radioBtnState: id,
		});
	}

	onLocationChangeHandler(e) {
		e.preventDefault();
		this.resetRadio();
		const value = e.currentTarget.dataset.value;
		this.setState({
			radioBtnState: value,
		});
	}

	onSubmitHandler() {
		this._onclickHandler(this.state.radioBtnState);
	}


	// ____________________________________ util ____________________________________

	resetRadio() {
		console.log('FIXME');
	}

	// ____________________________________ render ____________________________________

	render() {
		// console.log(this.props.locationArray);

		return (
			<div className="container-select select-location">
				<div className="row">
					<div className="col-12 col-md-7">

						{/*
						<h3>{(this.state.radioBtnState === '') ? "Choose location" : this.state.radioBtnState}</h3>
						*/}

						<div className="select-intro">
							<p>{i18n.t('select.location.intro')}</p>
							<p className="caption">{i18n.t('select.location.caption')}</p>
						</div>
					</div>

					<div className="col-12 col-md-5 dropdown-wrapper">
						<DropDown description={i18n.t('select.location.dropdown')} array={this.props.locationArray} onClick={(e) => this.onLocationChangeHandler(e)} />
					</div>

				</div>
				<div className="row">
					{
						this.radioArr.map((value, key) =>
							<div className="col-12 col-sm-6 col-md-4" key={key}>

								<div className="custom-control custom-radio custom-control-inline">
									<input
										className="custom-control-input"
										type="radio"
										name="locationRadio"
										value={value}
										id={value}
										onChange={(e) => this.onRadioChangeHandler(e)}
										disabled={this.isRadioDisabled(value)}
									/>
									<label className="custom-control-label" htmlFor={value}>
										{value}
									</label>
								</div>
							</div>
						)
					}
				</div>

				<SelectApplyBtn
					isdisabled={this.state.radioBtnState === ''}
					onClick={(e) => this.onSubmitHandler()}
					onApplyClick={(e) => this.props.onApplyClick(e, `${this.props.selectedState}`, `${this.state.radioBtnState}`)}
				/>

			</div>
		);
	}
}

export default withTranslation()(SelectLocation);
